import Section from '../components/Section';
import Button from '../components/Button';
import ServiceCard from '../components/ServiceCard';

const Home = () => {
  const services = [
    {
      title: 'Performance Consultancy',
      items: [
        'Performance analysis and KPI evaluation',
        'Process reviews and operational optimisation',
        'Tailored improvement plans aligned to budget',
        'Clear ROI measurement'
      ]
    },
    {
      title: 'Management Development',
      items: [
        'Leadership mentoring',
        'Recruitment support and talent evaluation',
        'Behavioural coaching',
        'Long-term capability building'
      ]
    },
    {
      title: 'High-Impact Sales Events',
      items: [
        'Weekend sales boosters',
        'Week-long intensive programmes',
        'On-site leadership support',
        'Real-time sales and profitability uplift'
      ]
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section 
        className="relative bg-summit-navy-dark text-white py-24"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1760092856749-31c8d5d28746?w=1600&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-summit-navy-dark opacity-85"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Driving Peak Performance in the Automotive Industry
            </h1>
            <p className="text-xl text-gray-200 mb-8">
              Specialist automotive consultancy and training designed to elevate dealership sales, leadership, and operational performance.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button to="/contact">Request a Consultation</Button>
              <Button to="/services" variant="secondary">Explore Our Services</Button>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Are */}
      <Section>
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-summit-navy-dark mb-6">Who We Are</h2>
          <p className="text-lg text-summit-grey leading-relaxed">
            Summit MCG is a specialist automotive consultancy and training group dedicated to improving performance across dealer networks.
          </p>
          <p className="text-lg text-summit-grey leading-relaxed mt-4">
            Our mission is simple: help retailers achieve peak operational, sales, and leadership performance through expert guidance, hands-on support, and proven best practice.
          </p>
        </div>
      </Section>

      {/* Divider */}
      <div className="border-t border-gray-200"></div>

      {/* Unmatched Industry Expertise */}
      <Section background="grey">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-summit-navy-dark mb-6">Unmatched Industry Expertise</h2>
            <p className="text-summit-grey leading-relaxed mb-4">
              Every Summit consultant brings a minimum of 15 years' senior management experience within franchised dealerships.
            </p>
            <p className="text-summit-grey leading-relaxed mb-4">
              Our team is selected not only for operational knowledge, but for the ability to train, coach, influence, and motivate teams at every level.
            </p>
            <p className="text-summit-grey leading-relaxed">
              Many consultants have international market experience, providing clients with access to broader insight and global best practice.
            </p>
          </div>
          <div>
            <img 
              src="https://images.unsplash.com/photo-1758518727613-00192aed759b?w=800&q=80" 
              alt="Leadership consultation" 
              className="rounded-sm shadow-lg"
            />
          </div>
        </div>
      </Section>

      {/* Divider */}
      <div className="border-t border-gray-200"></div>

      {/* What We Deliver */}
      <Section>
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-summit-navy-dark mb-4">What We Deliver</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
        <div className="max-w-3xl mx-auto bg-summit-navy-light text-white p-8 rounded-sm">
          <p className="text-center leading-relaxed">
            What sets Summit apart is on-site partnership. We do not train and leave. We work alongside your management team throughout delivery, guiding activity and driving measurable results in real time.
          </p>
        </div>
      </Section>

      {/* Divider */}
      <div className="border-t border-gray-200"></div>

      {/* Results-Focused Approach */}
      <Section background="grey">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://images.unsplash.com/photo-1758518729841-308509f69a7f?w=800&q=80" 
              alt="Performance analysis" 
              className="rounded-sm shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-3xl font-bold text-summit-navy-dark mb-6">Consultancy That Delivers Measurable Improvement</h2>
            <p className="text-summit-grey leading-relaxed mb-4">
              Every programme is built around commercial impact. We focus on sustainable behavioural change, process clarity, and measurable performance outcomes.
            </p>
            <p className="text-summit-grey leading-relaxed font-semibold">
              Our objective is not activity. It is results.
            </p>
          </div>
        </div>
      </Section>

      {/* Divider */}
      <div className="border-t border-gray-200"></div>

      {/* Final CTA */}
      <Section>
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-summit-navy-dark mb-4">Your Partner in Achieving Peak Performance</h2>
          <p className="text-lg text-summit-grey mb-8">
            In an increasingly competitive market, Summit provides the structure, leadership support, and industry expertise required to help dealer teams perform at their best.
          </p>
          <Button to="/contact">Speak to Summit</Button>
        </div>
      </Section>
    </>
  );
};

export default Home;